import Headroom from '../plugins/HeadroomPlugin.js';

export default function initHeadroom() {
	jQuery('#header-portal').each(function(i, header) {
		const headroom = new Headroom(this, {
			offset: {
				up: 0,
				down: 60
			},
			onPin : function() {
				jQuery(header).trigger('pin');
			},
			onUnpin : function() {
				jQuery(header).trigger('unpin');
			},
		});
		const resizeObserver = new ResizeObserver(resizeHandler);

		// initialise
		headroom.init();

		jQuery(header).data('headroom', headroom);

		function resizeHandler() {
			document.documentElement.style.setProperty('--header-height', jQuery(header).outerHeight() + 'px');
		}

		resizeObserver.observe(document.body);
	});

    jQuery('.nav-page-panel').each(function(i, header) {
		const headroom = new Headroom(this, {
			offset: {
				up: 0,
				down: 60
			},
			onPin : function() {
				jQuery(header).trigger('pin');
			},
			onUnpin : function() {
				jQuery(header).trigger('unpin');
			},
		});
		const resizeObserver = new ResizeObserver(resizeHandler);

		// initialise
		headroom.init();

		jQuery(header).data('headroom', headroom);

		function resizeHandler() {
			document.documentElement.style.setProperty('--nav-page-panel-height', jQuery(header).outerHeight() + 'px');
		}

		resizeObserver.observe(document.body);
	});
}